<script setup lang="ts">
import merge from 'lodash-es/merge';

defineOptions({
    name: 'WidgetInformationsSettings'
});

interface FormSettings
{
    settings: any;
}

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const { $t } = useLocalization();

const module = ref('informations');
const defaults = ref<any>({
    page: null,
    tags: [],
    hasPriority: false,
    quantity: 3
});

const form = computed<FormType<FormSettings>>(() =>
{
    return props.modelValue;
});

const quantity = computed<Option<number>[]>(() =>
{
    return new Array(10).fill(null).map((value, index) =>
    {
        return { value: index + 1, text: (index + 1).toString() };
    });
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function validate(): Promise<void>
{
    form.value.validate(schema => ({
        settings: schema.object({
            page: schema.string().nullable().required($t('[[[Wybranie strony jest wymagane]]]'))
        })
    }));
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});

defineExpose({
    validate
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Aktualności ze strony]]]')" :invalid-feedback="form.$errors.first('settings.page')" :state="form.$errors.state('settings.page')" required>
        <EditoPageSelector
            v-model="form.settings.page"
            :module="module"
            label=""
            :website="false"
            :preview="false"
            class="mb-0"
        />
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Zawierające jeden z wybranych tagów]]]')" :invalid-feedback="form.$errors.first('settings.tags')" :state="form.$errors.state('settings.tags')">
        <EditoTags v-model="form.settings.tags" />
    </IdeoFormGroup>
    <IdeoFormGroup>
        <IdeoFormCheckbox v-model="form.settings.hasPriority">
            {{ $t('[[[Tylko priorytetowe]]]') }}
        </IdeoFormCheckbox>
    </IdeoFormGroup>
    <IdeoFormGroup :label="$t('[[[Ilość wyświetlanych aktualności]]]')" :invalid-feedback="form.$errors.first('settings.quantity')" :state="form.$errors.state('settings.quantity')">
        <IdeoFormSelect v-model="form.settings.quantity" name="settings.quantity" :options="quantity" />
    </IdeoFormGroup>
</template>
